export const getArrayFromCSVText = text =>
  (text || '')
    .split('\n')
    .join(',')
    .split(';')
    .join(',')
    .split(',')
    .filter(item => item && item.length > 0);
